import Home from '../src/Home/index.tsx';
export default Home;
